export const trackLengthFormat = (seconds: number): string => {
  const hours = Math.floor(seconds / 3600);
  const minutesNumber = Math.floor((seconds % 3600) / 60);
  const remainingSecondsNumber = seconds % 60;

  // Pad minutes and seconds with leading zeros if needed
  const minutes = minutesNumber.toString().padStart(2, "0");
  const remainingSeconds = remainingSecondsNumber.toString().padStart(2, "0");

  if (hours > 0) {
    // Format as h:mm:ss
    return `${hours}:${minutes}:${remainingSeconds}`;
  } else {
    // Format as mm:ss if no hours
    return `${minutes}:${remainingSeconds}`;
  }
};
